import { useState } from 'react';

export const useTheme = () => {
  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const themeClass = darkMode
    ? 'bg-slate-900 text-white'
    : 'bg-gradient-to-br from-blue-50 to-white';
  const cardClass = darkMode
    ? 'bg-slate-800 border-slate-700 shadow-lg'
    : 'bg-white border-slate-100 shadow-xl';
  const headerClass = darkMode
    ? 'bg-slate-800 border-slate-700 backdrop-blur-md bg-opacity-90'
    : 'bg-white/90 border-slate-100 backdrop-blur-md';
  const inputClass = darkMode
    ? 'bg-slate-700 border-slate-600 text-white focus:ring-cyan-500 focus:border-cyan-500'
    : 'bg-white border-slate-200 focus:ring-blue-500 focus:border-blue-500';
  const accentClass = darkMode ? 'text-cyan-400' : 'text-blue-600';

  return {
    darkMode,
    toggleDarkMode,
    themeClass,
    cardClass,
    headerClass,
    inputClass,
    accentClass
  };
};

export default useTheme;
